/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2021 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { publicApiNames } from "publicApis/constants";
import { apiFactory } from "api/external/ApiFactory";
import docApi from "api";
import { getPageOverlayApis } from "selectors/overlayDropinSelectors";

const getFillAndSignApis = stores => {
  function getFASFields(pageNum) {
    return docApi.getFASFields(pageNum);
  }

  function createFASField(pageNum, data) {
    return docApi.createFASField(pageNum, data);
  }

  function flattenFASFields(forceFlatten = false) {
    return docApi.flattenFASFields(forceFlatten);
  }

  function deleteFASField(pageNum, id) {
    return docApi.deleteFASField(pageNum, id);
  }

  function updateFASField(pageNum, id, data) {
    return docApi.updateFASField(pageNum, id, data);
  }

  function getFASFieldAppearance(pageNum, id) {
    return docApi.getFASFieldAppearance(pageNum, id);
  }

  function lockFormFields() {
    // update in forms UI
    const overlayApis = getPageOverlayApis(stores, "acroform");
    if (overlayApis) {
      overlayApis.lockAcroFormFields();
    }
    // update in core
    return docApi.lockAcroFormFields();
  }

  return {
    getFASFields,
    createFASField,
    flattenFASFields,
    deleteFASField,
    updateFASField,
    getFASFieldAppearance,
    lockFormFields
  };
};

export const registerFillAndSignApis = stores => {
  apiFactory.registerApi(publicApiNames.FILLANDSIGN, clientName => getFillAndSignApis(stores), true);
};
